import { useState, useEffect, useRef } from 'react';

const useDropdownAnimation = (open, setOpen, enterClass, exitClass) => {
  const [visible, setVisible] = useState(false);
  const [animationClass, setAnimationClass] = useState('');
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleOpen = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setVisible(true);
    setAnimationClass(enterClass);
    setOpen(true);
  };

  const handleClose = () => {
    setAnimationClass(exitClass);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setVisible(false);
      setOpen(false);
      timeoutRef.current = null;
    }, 300);
  };

  const handleToggle = () => {
    open ? handleClose() : handleOpen();
  };

  return {
    visible,
    animationClass,
    handleToggle,
    handleClose,
  };
};

export default useDropdownAnimation;
